import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/C4E.svg'
import _imports_1 from '../../assets/stablecoin.png'
import _imports_2 from '../../assets/sepoliaIcon.svg'
import _imports_3 from '../../assets/BSCIcon.png'
import _imports_4 from '../../assets/PolygonIcon.png'
import _imports_5 from '../../assets/USDC-icon.png'
import _imports_6 from '../../assets/USDT-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-c7554830"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "allocationInfo" }
const _hoisted_2 = { class: "allocationInfo__head" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  key: 0,
  class: "title",
  style: {"float":"right","text-align":"center"}
}
const _hoisted_5 = { class: "allocationInfo__container" }
const _hoisted_6 = { class: "allocationInfo__body" }
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { class: "table__first_column" }
const _hoisted_9 = { class: "allocationInfo__table" }
const _hoisted_10 = { class: "allocationInfo__tableTabs" }
const _hoisted_11 = { class: "allocationInfo__tableTabs" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"23px","margin-right":"8px"},
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "allocationInfo__tableTabs" }, "Date", -1 /* HOISTED */))
const _hoisted_14 = { class: "allocationInfo__tableTabs" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "allocationInfo__tableTabs" }
const _hoisted_17 = { class: "allocationInfo__tableTabs" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "allocationInfo__tableTabs" }
const _hoisted_20 = { class: "allocationInfo__tableTabs" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "allocationInfo__tableTabs" }, "Round", -1 /* HOISTED */))
const _hoisted_22 = { class: "allocationInfo__tableTabs" }
const _hoisted_23 = { class: "table__second_column" }
const _hoisted_24 = {
  key: 0,
  cellspacing: "0",
  cellpadding: "0",
  class: "allocationInfo__table smaller"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "allocationInfo__tableTabs" }, "Left to pay", -1 /* HOISTED */))
const _hoisted_27 = { class: "allocationInfo__tableTabs" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "stablecoin symbol",
  style: {"width":"23px","margin-right":"8px"}
}, null, -1 /* HOISTED */))
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "allocationInfo__tableTabs" }, "Left to buy", -1 /* HOISTED */))
const _hoisted_31 = { class: "allocationInfo__tableTabs" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"23px","margin-right":"8px"},
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_33 = { key: 2 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "allocationInfo__tableTabs" }, "Overpaid", -1 /* HOISTED */))
const _hoisted_35 = { class: "allocationInfo__tableTabs" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"23px","margin-right":"8px"},
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_37 = { key: 3 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_39 = { key: 4 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1 /* HOISTED */))
const _hoisted_41 = {
  key: 0,
  class: "transactions"
}
const _hoisted_42 = { class: "accordion_container" }
const _hoisted_43 = {
  class: "accordion_container__content",
  style: {"max-width":"70%"}
}
const _hoisted_44 = {
  key: 0,
  style: {"text-align":"left","width":"200px"}
}
const _hoisted_45 = {
  key: 0,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_2,
  alt: "stablecoin symbol"
}
const _hoisted_46 = {
  key: 1,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_3,
  alt: "stablecoin symbol"
}
const _hoisted_47 = {
  key: 2,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_4,
  alt: "stablecoin symbol"
}
const _hoisted_48 = ["href"]
const _hoisted_49 = {
  key: 1,
  style: {"white-space":"nowrap","padding":"0 30px"}
}
const _hoisted_50 = {
  key: 0,
  style: {"margin-right":"5px"}
}
const _hoisted_51 = {
  key: 1,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_5,
  alt: "stablecoin symbol"
}
const _hoisted_52 = {
  key: 2,
  style: {"margin-right":"5px"}
}
const _hoisted_53 = {
  key: 3,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_6,
  alt: "stablecoin symbol"
}
const _hoisted_54 = {
  key: 2,
  style: {"text-align":"left"}
}
const _hoisted_55 = ["href"]
const _hoisted_56 = {
  key: 3,
  style: {"white-space":"nowrap","padding":"0 60px"}
}
const _hoisted_57 = { style: {"margin-right":"5px"} }
const _hoisted_58 = {
  key: 4,
  style: {"padding":"0 30px"}
}
const _hoisted_59 = {
  class: "title",
  style: {"float":"right"}
}
const _hoisted_60 = { class: "reservation_table" }
const _hoisted_61 = { style: {"width":"100%","table-layout":"fixed","border-collapse":"separate","border-spacing":"6px"} }
const _hoisted_62 = { key: 0 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "reservation_table__tab" }, "Blockchain", -1 /* HOISTED */))
const _hoisted_64 = { class: "reservation_table__tab" }
const _hoisted_65 = {
  key: 0,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_2,
  alt: "stablecoin symbol"
}
const _hoisted_66 = {
  key: 1,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_3,
  alt: "stablecoin symbol"
}
const _hoisted_67 = {
  key: 2,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_4,
  alt: "stablecoin symbol"
}
const _hoisted_68 = { key: 1 }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "reservation_table__tab" }, "TxHash", -1 /* HOISTED */))
const _hoisted_70 = { class: "reservation_table__tab" }
const _hoisted_71 = ["href"]
const _hoisted_72 = { key: 2 }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "reservation_table__tab" }, "Payments ", -1 /* HOISTED */))
const _hoisted_74 = { class: "row_visible" }
const _hoisted_75 = { class: "no_wrap" }
const _hoisted_76 = {
  key: 0,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_5,
  alt: "stablecoin symbol"
}
const _hoisted_77 = {
  key: 1,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_6,
  alt: "stablecoin symbol"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "gg-arrow-long-right" }, null, -1 /* HOISTED */))
const _hoisted_79 = { class: "no_wrap" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_81 = { key: 3 }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "reservation_table__tab" }, "Payments ", -1 /* HOISTED */))
const _hoisted_83 = { class: "row_visible" }
const _hoisted_84 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "gg-arrow-long-right" }, null, -1 /* HOISTED */))
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_87 = { key: 0 }
const _hoisted_88 = {
  key: 0,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_5,
  alt: "stablecoin symbol"
}
const _hoisted_89 = {
  key: 1,
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_6,
  alt: "stablecoin symbol"
}
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "gg-arrow-long-right" }, null, -1 /* HOISTED */))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_0
}, null, -1 /* HOISTED */))
const _hoisted_92 = {
  key: 0,
  class: "under_table_visible"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "gg-arrow-long-right" }, null, -1 /* HOISTED */))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"23px","margin-right":"4px"},
  src: _imports_0
}, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Allocation info (" + _toDisplayString($setup.getRoundName($props.transaction.roundId)) + ")", 1 /* TEXT */),
      _createElementVNode("div", {
        class: _normalizeClass(["payment-status", $setup.getReservationStatusClass($props.transaction, $setup.remainingTime)]),
        style: {"float":"right","text-align":"center"}
      }, [
        _createVNode(_component_Icon, {
          name: $setup.getReservationIcon($props.transaction, $setup.remainingTime)
        }, null, 8 /* PROPS */, ["name"]),
        _createTextVNode("   " + _toDisplayString($setup.getAllocationInfoStatus($props.transaction, $setup.remainingTime)), 1 /* TEXT */)
      ], 2 /* CLASS */),
      ($props.transaction.unconfirmed)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _createVNode(_component_Icon, {
              style: {"width":"30px","height":"30px","margin-bottom":"2px"},
              name: "Clock"
            }),
            _createTextVNode(" Waiting for confirmation ")
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.AMOUNT_REQUESTED')), 1 /* TEXT */),
                _createElementVNode("th", _hoisted_11, [
                  _hoisted_12,
                  _createVNode($setup["CoinAmount"], {
                    amount: $props.transaction.amountRequested,
                    "show-denom": true,
                    "reduce-big-number": false,
                    precision: 2
                  }, null, 8 /* PROPS */, ["amount"])
                ])
              ]),
              _createElementVNode("tr", null, [
                _hoisted_13,
                _createElementVNode("th", _hoisted_14, _toDisplayString($setup.formattedDate($props.transaction.timestamp)), 1 /* TEXT */)
              ]),
              ($setup.showRemainingTime($props.transaction, $setup.remainingTime))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.REMAINING_RESERVATION_TIME')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_17, _toDisplayString($setup.formatRemainingTime($setup.remainingTime)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              ($setup.showExpirationDate($props.transaction, $setup.remainingTime))
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('BUY_TOKENS_VIEW.EXPIRATION_DATE')), 1 /* TEXT */),
                    _createElementVNode("th", _hoisted_20, _toDisplayString($setup.formattedDate($props.transaction.reservationEndTime)), 1 /* TEXT */)
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("tr", null, [
                _hoisted_21,
                _createElementVNode("th", _hoisted_22, _toDisplayString($setup.getRoundName($props.transaction.roundId)), 1 /* TEXT */)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            ($props.transaction.status == $setup.RESERVATION_STATUS.DECLARED || $props.transaction.status == $setup.RESERVATION_STATUS.PARTIALLY_PAID || $props.transaction.status == $setup.RESERVATION_STATUS.OVERPAID)
              ? (_openBlock(), _createElementBlock("table", _hoisted_24, [
                  ($props.transaction.status == $setup.RESERVATION_STATUS.DECLARED || $props.transaction.status == $setup.RESERVATION_STATUS.PARTIALLY_PAID)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("th", _hoisted_27, [
                          _hoisted_28,
                          _createTextVNode(" " + _toDisplayString($props.transaction.leftToPayInStableCoin().toFixed(6)) + " USDC/USDT ", 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($props.transaction.status == $setup.RESERVATION_STATUS.DECLARED || $props.transaction.status == $setup.RESERVATION_STATUS.PARTIALLY_PAID)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("th", _hoisted_31, [
                          _hoisted_32,
                          _createTextVNode(" " + _toDisplayString($props.transaction.leftToBuyC4E().toFixed(6)) + " C4E ", 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($props.transaction.status == $setup.RESERVATION_STATUS.OVERPAID)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("th", _hoisted_35, [
                          _hoisted_36,
                          _createTextVNode(" " + _toDisplayString($props.transaction.getOverpaid().toFixed(6)) + " USDC/USDT ", 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  (($props.transaction.status == $setup.RESERVATION_STATUS.DECLARED || $props.transaction.status == $setup.RESERVATION_STATUS.PARTIALLY_PAID) && !$setup.isExpired($setup.remainingTime))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("th", null, [
                          ($setup.props.transaction.status === $setup.RESERVATION_STATUS.DECLARED || $setup.props.transaction.status === $setup.RESERVATION_STATUS.PARTIALLY_PAID)
                            ? (_openBlock(), _createBlock(_component_Button, {
                                key: 0,
                                class: "p-button p-component secondary accountInfo__btn allocationInfo__btn",
                                onClick: $setup.submit
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Pay")
                                ]),
                                _: 1 /* STABLE */
                              }))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.showAllocationCancelButton($props.transaction, $setup.remainingTime))
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("th", null, [
                          _createVNode(_component_Button, {
                            class: "p-button p-component accountInfo__btn allocationInfo__btn",
                            onClick: $setup.cancelAllocation,
                            severity: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Cancel")
                            ]),
                            _: 1 /* STABLE */
                          })
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      ($props.transaction.transactions.length>0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_41, " Transactions "))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["Accordion"], {
        multiple: true,
        style: {"white-space":"normal"}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.transaction.transactions, (blockchainTransaction) => {
            return (_openBlock(), _createBlock($setup["AccordionTab"], { key: blockchainTransaction }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    (blockchainTransaction.type ==$setup.PAYMENT_TYPE.COIN)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createCommentVNode("            {{$t('ENUMS.BLOCKCHAIN_STATUS.'+blockchainTransaction.blockchainStatus)}} - {{blockchainTransaction.txHash}}"),
                          (blockchainTransaction.blockchain == $setup.CHAIN_NAME.SEPOLIA)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_45))
                            : _createCommentVNode("v-if", true),
                          (blockchainTransaction.blockchain == $setup.CHAIN_NAME.BSC)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_46))
                            : _createCommentVNode("v-if", true),
                          (blockchainTransaction.blockchain == $setup.CHAIN_NAME.POLYGON)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_47))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("a", {
                            style: {"margin-left":"10px"},
                            href: blockchainTransaction.getTransactionLink(),
                            target: "_blank"
                          }, "TX: " + _toDisplayString($setup.addDotsInsideTooLongString(blockchainTransaction.txHash, 10)), 9 /* TEXT, PROPS */, _hoisted_48)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (blockchainTransaction.type ==$setup.PAYMENT_TYPE.COIN)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          (blockchainTransaction.getSumOfPayments($setup.TOKEN_NAME.USDC).isBiggerThan(0))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(blockchainTransaction.getSumOfPayments($setup.TOKEN_NAME.USDC).toFixed(2)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (blockchainTransaction.getSumOfPayments($setup.TOKEN_NAME.USDC).isBiggerThan(0))
                            ? (_openBlock(), _createElementBlock("img", _hoisted_51))
                            : _createCommentVNode("v-if", true),
                          (blockchainTransaction.getSumOfPayments($setup.TOKEN_NAME.USDT).isBiggerThan(0))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(blockchainTransaction.getSumOfPayments($setup.TOKEN_NAME.USDT).toFixed(2)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (blockchainTransaction.getSumOfPayments($setup.TOKEN_NAME.USDT).isBiggerThan(0))
                            ? (_openBlock(), _createElementBlock("img", _hoisted_53))
                            : _createCommentVNode("v-if", true)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (blockchainTransaction.type ==$setup.PAYMENT_TYPE.FIAT)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          _createVNode($setup["CountryFlag"], {
                            country: $setup.getFlagSelector(blockchainTransaction.currencyCode)
                          }, null, 8 /* PROPS */, ["country"]),
                          _createElementVNode("a", {
                            style: {"margin-right":"10px","margin-left":"10px"},
                            href: blockchainTransaction.getTransactionLink(),
                            target: "_blank"
                          }, _toDisplayString(blockchainTransaction.currencyCode) + " Payment", 9 /* TEXT, PROPS */, _hoisted_55)
                        ]))
                      : _createCommentVNode("v-if", true),
                    (blockchainTransaction.type ==$setup.PAYMENT_TYPE.FIAT)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _createElementVNode("span", _hoisted_57, _toDisplayString(blockchainTransaction.amount), 1 /* TEXT */),
                          _createVNode($setup["CountryFlag"], {
                            country: $setup.getFlagSelector(blockchainTransaction.currencyCode)
                          }, null, 8 /* PROPS */, ["country"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (blockchainTransaction.blockchainStatus == $setup.BLOCKCHAIN_STATUS.UNCONFIRMED)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                          _createElementVNode("span", _hoisted_59, [
                            _createVNode(_component_Icon, {
                              style: {"width":"30px","height":"30px","margin-bottom":"2px"},
                              name: "Clock"
                            }),
                            _createTextVNode(" Waiting for confirmation ")
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["transaction_status transaction_status-completed", $setup.getTransactionStatusClass(blockchainTransaction.status)])
                  }, _toDisplayString($setup.i18n.t('ENUMS.TRANSACTION_STATUS.'+blockchainTransaction.status)), 3 /* TEXT, CLASS */)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("table", _hoisted_61, [
                    (blockchainTransaction.blockchain)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("th", _hoisted_64, [
                            (blockchainTransaction.blockchain == $setup.CHAIN_NAME.SEPOLIA)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_65))
                              : _createCommentVNode("v-if", true),
                            (blockchainTransaction.blockchain == $setup.CHAIN_NAME.BSC)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_66))
                              : _createCommentVNode("v-if", true),
                            (blockchainTransaction.blockchain == $setup.CHAIN_NAME.POLYGON)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_67))
                              : _createCommentVNode("v-if", true),
                            _createTextVNode(" " + _toDisplayString(blockchainTransaction.blockchain), 1 /* TEXT */)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (blockchainTransaction.txHash)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("th", _hoisted_70, [
                            _createElementVNode("a", {
                              href: blockchainTransaction.getTransactionLink(),
                              target: "_blank"
                            }, _toDisplayString($setup.addDotsInsideTooLongString(blockchainTransaction.txHash, 28)), 9 /* TEXT, PROPS */, _hoisted_71)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode("            <tr>"),
                    _createCommentVNode("              <th class=\"reservation_table__tab\">Type</th>"),
                    _createCommentVNode("              <th class=\"reservation_table__tab\">{{ blockchainTransaction.type }}</th>"),
                    _createCommentVNode("            </tr>"),
                    _createCommentVNode("            <tr v-if=\"blockchainTransaction.amount\">"),
                    _createCommentVNode("              <th class=\"reservation_table__tab\">Amount</th>"),
                    _createCommentVNode("              <th class=\"reservation_table__tab\">{{ blockchainTransaction.amount }}</th>"),
                    _createCommentVNode("            </tr>"),
                    _createCommentVNode("            <tr v-if=\"blockchainTransaction.currencyCode\">"),
                    _createCommentVNode("              <th class=\"reservation_table__tab\">Currency</th>"),
                    _createCommentVNode("              <th class=\"reservation_table__tab\">{{ blockchainTransaction.currencyCode }}</th>"),
                    _createCommentVNode("            </tr>"),
                    (blockchainTransaction.blockchainTxs.length>0 && blockchainTransaction.type == $setup.PAYMENT_TYPE.COIN)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [
                          _hoisted_73,
                          _createElementVNode("th", _hoisted_74, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockchainTransaction.blockchainTxs, (blockchainTx) => {
                              return (_openBlock(), _createElementBlock("div", {
                                style: {"display":"flex","align-items":"center","width":"100%"},
                                key: blockchainTx
                              }, [
                                _createElementVNode("span", _hoisted_75, [
                                  (blockchainTx.coinName == $setup.TOKEN_NAME.USDC)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_76))
                                    : _createCommentVNode("v-if", true),
                                  (blockchainTx.coinName == $setup.TOKEN_NAME.USDT)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_77))
                                    : _createCommentVNode("v-if", true),
                                  _createTextVNode(" " + _toDisplayString(blockchainTx.amount) + " " + _toDisplayString(blockchainTx.coinName), 1 /* TEXT */)
                                ]),
                                _hoisted_78,
                                _createElementVNode("span", _hoisted_79, [
                                  _createCommentVNode("                          <img style=\"width: 23px; margin-right:4px;\" src=\"@/assets/svg/C4E.svg\"> &#8773; {{blockchainTx.getInC4E().toFixed(6)}} C4E"),
                                  _hoisted_80,
                                  _createTextVNode(" ≈ " + _toDisplayString(blockchainTx.getInC4E().toFixed(6)) + " C4E ", 1 /* TEXT */)
                                ])
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (blockchainTransaction.type == $setup.PAYMENT_TYPE.FIAT)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_81, [
                          _hoisted_82,
                          _createElementVNode("th", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createVNode($setup["CountryFlag"], {
                                country: $setup.getFlagSelector(blockchainTransaction.currencyCode)
                              }, null, 8 /* PROPS */, ["country"]),
                              _createTextVNode("   " + _toDisplayString(blockchainTransaction.amount) + " " + _toDisplayString(blockchainTransaction.currencyCode) + " ", 1 /* TEXT */),
                              _hoisted_85,
                              _hoisted_86,
                              _createTextVNode("~" + _toDisplayString(blockchainTransaction.amount*$setup.exchangeRateMap.get(blockchainTransaction.currencyCode)?.toFixed(6)) + " C4E ", 1 /* TEXT */)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (blockchainTransaction.type == $setup.PAYMENT_TYPE.COIN)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(blockchainTransaction.blockchainTxs, (blockchainTx) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "under_table_visible",
                            key: blockchainTx
                          }, [
                            (blockchainTx.coinName == $setup.TOKEN_NAME.USDC)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_88))
                              : _createCommentVNode("v-if", true),
                            (blockchainTx.coinName == $setup.TOKEN_NAME.USDT)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_89))
                              : _createCommentVNode("v-if", true),
                            _createTextVNode(" " + _toDisplayString(blockchainTx.amount) + " " + _toDisplayString(blockchainTx.coinName) + " ", 1 /* TEXT */),
                            _hoisted_90,
                            _hoisted_91,
                            _createTextVNode("~" + _toDisplayString(blockchainTx.getInC4E().toFixed(6)) + " C4E ", 1 /* TEXT */)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                (blockchainTransaction.type == $setup.PAYMENT_TYPE.FIAT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      _createVNode($setup["CountryFlag"], {
                        country: $setup.getFlagSelector(blockchainTransaction.currencyCode)
                      }, null, 8 /* PROPS */, ["country"]),
                      _createTextVNode("   " + _toDisplayString(blockchainTransaction.amount) + " " + _toDisplayString(blockchainTransaction.currencyCode) + " ", 1 /* TEXT */),
                      _hoisted_93,
                      _hoisted_94,
                      _createTextVNode("~" + _toDisplayString(blockchainTransaction.amount*$setup.exchangeRateMap.get(blockchainTransaction.currencyCode)?.toFixed(6)) + " C4E ", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}